import { render, staticRenderFns } from "./NewMajorConfigModal.vue?vue&type=template&id=1feaa5df&scoped=true"
import script from "./NewMajorConfigModal.vue?vue&type=script&lang=js"
export * from "./NewMajorConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1feaa5df",
  null
  
)

export default component.exports